import { hotList } from "@/mocks/sections";

interface HotProps {
  onQuery: (term: string) => void;
}

const rankColor = (rank: number) =>
  rank <= 3
    ? "bg-accent-500 text-background-50"
    : "bg-secondary-100 text-secondary-900";

const changeIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-600",
  down: "ri-arrow-down-line text-foreground-400",
  new: "ri-flashlight-line text-secondary-600",
  flat: "ri-subtract-line text-foreground-300",
};

export default function Hot({ onQuery }: HotProps) {
  return (
    <section id="hot" className="scroll-mt-16 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.2em] text-accent-600">
              <i className="ri-fire-fill text-sm leading-none"></i>
              热榜速览 TRENDING
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今天大家都在查什么
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-600">
              根据近期全网讨论热度整理的吃瓜热词榜，点击任意热词即可查看完整词条解释。
            </p>
          </div>
          <button
            onClick={() => onQuery("")}
            className="hidden shrink-0 whitespace-nowrap items-center gap-1 rounded-md bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 ring-1 ring-background-300 transition-colors hover:bg-primary-100 hover:text-primary-800 md:inline-flex cursor-pointer"
          >
            浏览全部
            <i className="ri-arrow-right-line text-sm leading-none"></i>
          </button>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
          {hotList.map((item) => (
            <button
              key={item.rank}
              onClick={() => onQuery(item.term)}
              className="group flex items-center gap-4 rounded-lg bg-background-100 px-4 py-3.5 text-left ring-1 ring-background-200 transition-all hover:-translate-y-0.5 hover:bg-background-50 hover:ring-primary-300 cursor-pointer"
            >
              <span
                className={`inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${rankColor(
                  item.rank
                )}`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap font-heading text-base font-bold text-foreground-950 group-hover:text-primary-700">
                    {item.term}
                  </span>
                  <i className={`${changeIcon[item.change]} text-sm leading-none`}></i>
                </div>
                <p className="mt-0.5 truncate text-xs text-foreground-500">{item.note}</p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1.5">
                <span className="text-sm font-semibold text-foreground-800">
                  {item.hot}
                  <span className="ml-0.5 text-[11px] font-normal text-foreground-400">热度</span>
                </span>
                <span className="h-1 w-16 overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-primary-500"
                    style={{ width: `${item.hot}%` }}
                  ></span>
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}